//region :: Imports ::
import React, {createRef, ReactElement, ReactNode, RefObject} from 'react';
import MComponent from '../Toolkit/Components/Component';
import {MCancelIconName, MIcon, MOkIconName} from '../Toolkit/Icons';
import {DialogPositionType} from 'primereact/dialog';
import Dialog from '../Toolkit/Components/Controls/Dialog';
import MButton from '../Toolkit/Components/Controls/Button';
import {MDropDownItem} from '../Toolkit/Components/Controls/DropDownOption';
import MFormControl from '../Toolkit/Components/Controls/FormControl';
import MTextBox from '../Toolkit/Components/Controls/TextBox';
import MDropDown from '../Toolkit/Components/Controls/DropDown';
import {Enumeration} from '../Api/ControllerTypes/EnumerationTypes';

//endregion

/** */
type Props = {
    fileTypeList: Enumeration[]
    fileFolderList: Enumeration[];
}

/** */
type State = {
    position?: DialogPositionType;
    visible: boolean;
    pageTitle: string;
    uploadData?: UploadData;
    editData?: EditData
    fileInfoOptions: MDropDownItem<number>[];
    onUploadFile?: (data: UploadData) => void;
    onEditFile? :(data: EditData) => void;
    uploading: boolean;
    editing: boolean;
}

export type UploadData = {
    file: File | undefined;
    fileType: number | undefined;
    fileFolder: number | undefined;
    note: string | undefined;
}

export type EditData = {
    id: string | undefined;
    fileType: number | undefined;
    fileFolder: number | undefined;
    note: string | undefined;
}

/** */
class FileUploadDialog extends MComponent<Props, State> {

    private UploadIcon: MIcon = {name: 'pi pi-upload', color: 'mcolor-info'};
    private readonly m_fileRef: RefObject<HTMLInputElement>;

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();

        this.m_fileRef = createRef<HTMLInputElement>();

        this.initializeState();
    }

    /** */
    private bindMethods(): void {
        this.dialog_onHide = this.dialog_onHide.bind(this);

        this.getDialogTemplate = this.getDialogTemplate.bind(this);
        this.onFileChange = this.onFileChange.bind(this);
        this.getFooterTemplate = this.getFooterTemplate.bind(this);
        this.ok_Click = this.ok_Click.bind(this);

        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
    }

    /** */
    private initializeState(): void {
        this.state = {
            visible: false,
            fileInfoOptions: [],
            pageTitle: 'File Upload',
            uploading: false,
            editing: false,
            uploadData: undefined,
            editData: undefined
        };
    }

    /** */
    private dialog_onHide(): void {
        this.safeSetState((draft: State) => draft.visible = false);
    }

    /** */
    public show(inputCallback: (data: UploadData) => void, position?: DialogPositionType) {

        this.safeSetState((draft: State) => {
            draft.position = position;
            draft.visible = true;
            draft.onUploadFile = inputCallback;
            draft.uploading = false;
            draft.editing = false;
            draft.uploadData = {
                file: undefined,
                fileType: -1,
                fileFolder: -1,
                note: ''
            };
        });
    }

    public edit(data: EditData, editCallback: (data: EditData) => void, position?: DialogPositionType) {

        this.safeSetState((draft: State) => {
            draft.position = position;
            draft.onEditFile = editCallback;
            draft.visible = true;
            draft.uploading = false;
            draft.editing = true;
            draft.editData = {
                id: data.id,
                fileType: data.fileType,
                fileFolder: data.fileFolder,
                note: data.note
            };
        });
    }

    public hide() {
        this.safeSetState((draft: State) => {
            draft.visible = false;
        });
    }

    private ok_Click() {
        if(!this.state.editing) {
            if(!this.state.uploading) {
                this.safeSetState((draft: State) => draft.uploading = true);
                this.state.onUploadFile!(this.state.uploadData!);
            }
        } else {
            this.state.onEditFile!(this.state.editData!);
        }
    }

    private getDialogTemplate(): ReactNode {
        const fileTypeRows = this.props.fileTypeList.map(fileType => ({
            value: fileType.id,
            label: fileType.name
        }));

        /*const folderRows = this.props.fileFolderList.map(folder => ({
            value: folder.id,
            label: folder.name
        }));*/

        return (
            <div className="formgrid grid">
                <div className="col-12 md:col-12">
                    <MFormControl label={'File Type'}
                                  id={'fileType'}>
                        {(fieldClasses: string | undefined) => {
                            return (
                                <MDropDown<number> id='fileTypeValue'
                                                   disabled={false}
                                                   items={fileTypeRows}
                                                   initialValue={this.state.editing ? this.state.editData!.fileType : this.state.uploadData!.fileType}
                                                   onChange={e => this.state.editing
                                                                  ? this.safeSetState((draft: State) => draft.editData!.fileType = e!)
                                                                  : this.safeSetState((draft: State) => draft.uploadData!.fileType = e!)}
                                />
                            );
                        }}
                    </MFormControl>
                </div>

                {/*<div className="col-12 md:col-12">
                    <MFormControl label={'Folder'}
                                  id={'fileFolder'}>
                        {(fieldClasses: string | undefined) => {
                            return (
                                <MDropDown<number> id='fileFolderValue'
                                                    disabled={false}
                                                    items={folderRows}
                                                    initialValue={this.state.editing ? this.state.editData!.fileFolder : this.state.uploadData!.fileFolder}
                                                    onChange={e => this.state.editing
                                                                   ? this.safeSetState((draft: State) => draft.editData!.fileFolder = e!)
                                                                   : this.safeSetState((draft: State) => draft.uploadData!.fileFolder = e!)}
                                />
                            );
                        }}
                    </MFormControl>
                </div>*/}

                <div className="col-12 md:col-12">
                    <MFormControl label={'Note'} id={'NoteField'}>
                        {(fieldClasses: string | undefined) => {
                            return (
                                <MTextBox id="Note Entry"
                                          disabled={false}
                                          initialValue={this.state.editing ? this.state.editData!.note : this.state.uploadData!.note}
                                          onChange={e => this.state.editing
                                                         ? this.safeSetState((draft: State) => draft.editData!.note = e!.toString())
                                                         : this.safeSetState((draft: State) => draft.uploadData!.note = e!.toString())}
                                          maxLength={255}
                                />
                            );
                        }}
                    </MFormControl>
                </div>
                <div>Drop files in the dashed area or click "Choose File" to browse</div>
                {!this.state.editing && <div style={{border: '1px dashed', padding: '40px 200px 40px 20px'}}
                                             onDrop={(evt) => {
                                                 evt.preventDefault();
                                                 this.m_fileRef.current!.files=evt.dataTransfer.files;
                                                 this.onFileChange(evt.dataTransfer.files);
                                             }}
                                             onDragOver={(evt) => {
                                                 evt.preventDefault();
                                             }}
                >
                    <input ref={this.m_fileRef}
                           id='fileInput'
                           type="file"
                           onChange={(evt) => this.onFileChange(evt.target.files)}
                           accept={'.msg,.jpg,.pdf,.doc,.docx,.xls,.xlsx'}/>
                </div>}
            </div>);
    }

    private getFooterTemplate(): ReactNode {
        return (
            <div>
                <MButton label="OK"
                         color="success"
                         icon={MOkIconName}
                         disabled={!this.isUploadAvailable()}
                         onClick={this.ok_Click}/>
                <MButton label="Cancel"
                         icon={MCancelIconName}
                         disabled={false}
                         onClick={this.hide}/>
            </div>
        );
    }

    private onFileChange(files: FileList | null) {
        const fileTypes = ['.msg','.jpg','.pdf','.doc','.docx','.xls','.xlsx'];

        if(files?.length) {
            if(fileTypes.some(s => files![0].name.toLowerCase().endsWith(s))) {
                this.safeSetState(
                    (draft: State) => draft.uploadData!.file = files![0]);
            } else {
                this.safeSetState(
                    (draft: State) => draft.uploadData!.file = undefined);
            }
        } else {
            this.safeSetState(
                (draft: State) => draft.uploadData!.file = undefined);
        }
    }

    private isUploadAvailable() {
        if(this.state.editing) {
            return !this.state.uploading &&
                (this.state.editData?.fileType ?? -1) > -1
        } else{
            return !this.state.uploading &&
                (this.state.uploadData?.fileType ?? -1) > -1 &&
                this.state.uploadData?.file !== undefined
        }
    }

    /** */
    public render(): ReactElement {

        return (
            <Dialog title={this.state.pageTitle}
                    content={this.getDialogTemplate()}
                    icon={this.UploadIcon}
                    footer={this.getFooterTemplate()}
                    position={this.state.position}
                    canClose={false}
                    closeOnEscape={false}
                    visible={this.state.visible}
                    onHide={this.dialog_onHide}/>
        );

    }

}

export default FileUploadDialog;
